
import cx from 'classnames'
import PropTypes from 'prop-types'

import ActionStatus from '../../../../lib/Codes/ActionStatuses'
import { FlatButton } from '../../../shared/NarusMaterial'
import './IssueFilters.styles.scss'

const IssueFilters = ({
  onChange,
  activeFilters,
  counts,
  statuses,
  compact
}) => {
  return (
    <div
      className={cx('nh-issue-filters', {
        compact,
        'between-xs': !compact
      })}
    >
      {(statuses || ActionStatus.all).map((s, index) => {
        let { label } = s
        if (counts) {
          const count = counts[s.value] ? counts[s.value] : 0
          label = `${s.label} ${count}`
        }
        return (
          <div
            key={index}
          >
            <FlatButton
              key={label}
              label={label}
              onClick={() => onChange(s.value)}
              grey={!activeFilters.includes(s.value)}
            />
          </div>
        )
      })}
    </div>
  )
}

IssueFilters.propTypes = {
  onChange: PropTypes.func.isRequired,
  activeFilters: PropTypes.instanceOf(Array).isRequired,
  childrenClassName: PropTypes.arrayOf(PropTypes.string),
  statuses: PropTypes.instanceOf(Array)
}

IssueFilters.defaultProps = {
  childrenClassName: [ 'col-xs-2' ]
}

export default IssueFilters
